// Image compression utility
export const compressImage = async (file) => {
  const fileSizeMB = file.size / (1024 * 1024);

  // Already small enough, no need to re-encode
  if (fileSizeMB <= 0.3) {
    return file;
  }

  let quality;
  if (fileSizeMB <= 1) {
    quality = 0.5;
  } else if (fileSizeMB <= 2) {
    quality = 0.3;
  } else {
    quality = 0.2;
  }

  const maxDimension = 1600;

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const scale = Math.min(1, maxDimension / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              console.log(
                `Compressed ${file.name}: ${fileSizeMB.toFixed(2)}MB -> ${(
                  blob.size /
                  (1024 * 1024)
                ).toFixed(2)}MB`
              );
              resolve(compressedFile);
            } else {
              reject(new Error("Compression failed"));
            }
          },
          "image/jpeg",
          quality
        );
      };
      img.onerror = () => reject(new Error("Failed to load image"));
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
  });
};
